import Phaser from "phaser";
import Hero from "../entities/Hero";
import Enemy from "../entities/Enemy";

const MAX_LEVELS = 10

class Game extends Phaser.Scene {
    constructor() {
        super({ key: 'GameScene' })

    }

    preload() {
        // console.log('PRELOAD()')
        
    }

    updateLives = (lives) => {
        // console.log(`updateLives(${lives})`)

        const addLife = () => {
            let life = this.add.image(10 + 80 * this.livesArray.length, 10, 'life')
            .setOrigin(0, 0)
            .setScrollFactor(0)
            .setDepth(15)
            this.livesArray.push(life)
        }

        const removeLife = () => {
            this.livesArray.pop()
                .destroy()
        }

        let size = this.livesArray.length

        if (lives > size) {
            let numLivesToAdd = lives - size
            for (let i = 0; i < numLivesToAdd; i++) {
                addLife()
            }
        } else if (lives < size) {
            let numLivesToRemove = size - lives
            for (let i = 0; i < numLivesToRemove; i++) {
                removeLife()
            }
        }

        
    }

    

    handleSceneReady = () => {
        // console.log(`handleSceneReady()`)
        if (typeof window.repositionControls === 'function') {
            window.repositionControls()
        }
    }

    create(data) {

        this.gameImagesX = this.cameras.main.width / 2
        this.gameImagesY = this.cameras.main.height / 2

        
        if (!window.gameStartConfig.areGameSoundsOn) {
            this.muteSounds()
        } else {
            this.unmuteSounds()
        }
        

        this.backgroundSound = this.sound.add('background', {
            loop: true,
            volume: 0.2
        })
        this.backgroundSound.play()

        this.jumpSound = this.sound.add('jump', {
            volume: 0.5
        })
        this.collectSound = this.sound.add('collect', {
            volume: 0.7
        })
        this.hitSound = this.sound.add('hit', {
            volume: 0.7
        })
        this.flagOverlapSound = this.sound.add('flagoverlap', {
            volume: 1
        })
        this.trampolineJumpSound = this.sound.add('trampolinejump', {
            volume: 1
        })
        this.failingSound = this.sound.add('failing', {
            volume: 0.7
        })
        this.killEnemySound = this.sound.add('killenemy', {
            volume: .7
        })
        this.heroDieSound = this.sound.add('herodie', {
            volume: 1
        })

        if (!data.level) {
            // console.log('Attached listener!')
            this.events.on('ready', this.handleSceneReady)
        }

        this.hasOverlappedFlag = false
        this.level = data.level || window.gameStartConfig.selectedLevel*1
        // score
        this.score = data.score || 0

        this.cat = {}

        this.ts = 0

        this.enemy = {
            c: 0,
            e: 0
        }

        this.selectedCat = window.gameStartConfig.selectedCat
        this.livesArray = []

        // console.log("Level "+ this.level)
        //
        // console.log('CREATE()')

        this.cursorKeys = this.input.keyboard.createCursorKeys()

        this.anims.create({
            key: 'flag-opening',
            frames: this.anims.generateFrameNumbers('flag', {start: 0, end: 2}),
            frameRate: 16,
            repeat: 0
        })
        this.anims.create({
            key: 'flag-flying',
            frames: this.anims.generateFrameNumbers('flag', {start: 3, end: 8}),
            frameRate: 16,
            repeat: -1
        })
        this.anims.create({
            key: 'cage-opening',
            frames: this.anims.generateFrameNumbers('cage'),
            frameRate: 30,
            repeat: 0
        })

        this.createHeroAnims()

        this.anims.create({
            key: 'wasp-walk',
            frames: this.anims.generateFrameNumbers('wasp-walk-sheet'),
            frameRate: 30,
            repeat: -1
        })
        this.anims.create({
            key: 'cartoon-wasp-walk',
            frames: this.anims.generateFrameNumbers('cartoon-wasp-walk-sheet'),
            frameRate: 12,
            repeat: -1
        })
        this.anims.create({
            key: 'mosquito-walk',
            frames: this.anims.generateFrameNumbers('mosquito-walk-sheet'),
            frameRate: 32,
            repeat: -1
        })
        this.anims.create({
            key: 'lava-walk',
            frames: this.anims.generateFrameNumbers('lava-walk-sheet'),
            frameRate: 16,
            repeat: -1
        })

        this.anims.create({
            key: 'trampoline-active',
            frames: this.anims.generateFrameNumbers('trampoline-sheet'),
            frameRate: 30,
            repeat: 0,
            yoyo: true
        })
        this.anims.create({
            key: 'basic-rat-walk',
            frames: this.anims.generateFrameNumbers('basic-rat-walk-sheet', {start: 0, end: 11}),
            frameRate: 30,
            repeat: -1
        })
        this.anims.create({
            key: 'white-rat-walk',
            frames: this.anims.generateFrameNumbers('white-rat-walk-sheet', {start: 0, end: 11}),
            frameRate: 50,
            repeat: -1
        })
        this.anims.create({
            key: 'basic-rat-dying',
            frames: this.anims.generateFrameNames('basic-rat-walk-sheet', {start: 12, end: 15}),
            frameRate: 24,
            repeat: 0
        })
        this.anims.create({
            key: 'white-rat-dying',
            frames: this.anims.generateFrameNames('white-rat-walk-sheet', {start: 12, end: 15}),
            frameRate: 24,
            repeat: 0
        })

        

        this.addMap()
        this.addFlagAndCage()
        this.addHero()
        this.addBG()

        this.enemyWallCollider = this.physics.add.collider(this.enemyGroup, this.map.getLayer('ActorColliders').tilemapLayer, (enemy) => {
            // if (enemy.enemyType === 'MovingPlatform') {
            //     console.log(enemy.enemyType, 'EnemyCollider')
            // }
            enemy.handleCollisionWithWall()
        })
        this.physics.world.on('worldbounds', this.handleCollideWorldBounds)

        this.enemyGroup.setDepth(1)

        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels)

        
        this.scoreText = this.add.text(this.cameras.main.width - 20, 10, `Level:${this.level} Score:${this.score}`, {
            fontSize: '32px',
            color: 'white',
            strokeThickness: 4,
            stroke: 'black',
            // fontFamily: 'Arial',
            // align: 'right'
        }).setOrigin(1, 0).setScrollFactor(0).setDepth(10)


        this.goBackImage = this.add.image(this.cameras.main.width - 20, this.cameras.main.height - 20, 'back')
            .setOrigin(1, 1)
            .setDisplaySize(96, 96)
            .setInteractive()
            .setScrollFactor(0)
            .setDepth(15)

        this.goBackImage.on('pointerdown', this.handleGoBack)
    }

    handleGoBack = () => {
        if (this.scene.isActive('BlankScene')) {
            // console.log('Blank Scene already running')
            return;
        }
        // if (typeof window.updateScore === 'function') {
        //     window.updateScore(this.level, this.score, false, this.cat, this.enemy, this.ts)
        // }
        if (typeof window.showReactApplication === 'function') {
            window.showReactApplication()
        }
        this.scene.start('BlankScene')
    }

    muteSounds = () => {
        this.game.sound.mute = true
    }
    unmuteSounds = () => {
        this.game.sound.mute = false
    }

    createHeroAnims = () => {
        for (let i = 1; i <= 10; i++) {
            this.anims.create({
                key: `hero-${i}-idle`,
                frames: this.anims.generateFrameNumbers(`hero-${i}-sheet`, {start: 0, end: 29}),
                frameRate: 30,
                repeat: -1
            })
            this.anims.create({
                key: `hero-${i}-falling`,
                frames: this.anims.generateFrameNumbers(`hero-${i}-sheet`, {start: 45, end: 50}),
                frameRate: 30,
                repeat: 0
            })
            this.anims.create({
                key: `hero-${i}-running`,
                frames: this.anims.generateFrameNumbers(`hero-${i}-sheet`, {start: 60, end: 76}),
                frameRate: 45,
                repeat: -1
            })
            this.anims.create({
                key: `hero-${i}-jumping`,
                frames: this.anims.generateFrameNumbers(`hero-${i}-sheet`, {start: 39, end: 44}),
                frameRate: 30,
                repeat: 0
            })
            this.anims.create({
                key: `hero-${i}-flipping`,
                frames: this.anims.generateFrameNumbers(`hero-${i}-sheet`, {start: 42, end: 44}),
                frameRate: 30,
                repeat: 0
            })
            this.anims.create({
                key: `hero-${i}-pivoting`,
                frames: this.anims.generateFrameNumbers(`hero-${i}-sheet`, {start: 51, end: 51}),
                // frameRate: 30,
                // repeat: 0
            })
            this.anims.create({
                key: `hero-${i}-dead`,
                frames: this.anims.generateFrameNumbers(`hero-${i}-sheet`, {start: 44, end: 44})
            })
        }
        
    }

    updateCat = (cat, ts) => { this.cat = cat; this.ts = ts }

    updateEnemy = (type, c = 1) =>
    {
        if(type === "BasicRat")
        {
            this.enemy.c += c
        }

        if(type === "WhiteRat")
        {
            this.enemy.e += c
        }
    }

    incrementScore = (amount=0) => {
        this.score += amount
        // console.log(`Level:${this.level} Score: ${this.score}, increment: ${amount}`)
        this.scoreText.setText(`Level:${this.level} Score:${this.score}`)
    }

    addBG = () => {
        this.add.tileSprite(0, 0, this.map.widthInPixels, this.cameras.main.height, `background-${this.level}-01`)
            .setOrigin(0,0)
            .setDepth(-10)
            .setScrollFactor(0.4, 0)
        this.add.tileSprite(0, 0, this.map.widthInPixels, this.cameras.main.height, `background-${this.level}-02`)
            .setOrigin(0,0)
            .setDepth(-10)
            .setScrollFactor(0.6, 0)
    }

    handleCollideWorldBounds = (body, up, down, left, right) => {
        // console.log('handleCollideWorldBounds')
        if (down) {
            if (body && 
                body.gameObject && 
                body.gameObject instanceof Hero &&
                body.gameObject.kill) {
                    body.gameObject.kill()
                    // console.log('die()')
                }
        }
    }

    addHero() {
        this.hero = new Hero(this, this.spawnPos.x, this.spawnPos.y)
        this.cameras.main.startFollow(this.hero)
        const groundCollider = this.physics.add.collider(this.hero, this.map.getLayer('Ground').tilemapLayer)

        const spikesCollider = this.physics.add.overlap(this.hero, this.spikeGroup, this.hero.handleSpikeCollision)

        const ladderCollider = this.physics.add.collider(this.hero, this.ladderGroup)
        const trampolineCollider = this.physics.add.collider(this.hero, this.trampolineGroup, this.hero.handleTrampolineCollision)
        const enemyCollider = this.physics.add.collider(this.hero, this.enemyGroup, this.hero.handleEnemyCollision)

        const collectableCollider = this.physics.add.overlap(this.hero, this.collectableGroup, this.hero.handleCollectableOverlap)
        const flagCollider = this.physics.add.overlap(this.hero, this.flag, this.handleFlagOverlap)
        
        let removedColliders = false;
        const removeCollidersOnce = () => {
            if (removedColliders) return;
            removedColliders = true;
            // console.log(`removeCollidersOnce()`)

            groundCollider.destroy()
            spikesCollider.destroy()
            ladderCollider.destroy()
            trampolineCollider.destroy()
            enemyCollider.destroy()
            collectableCollider.destroy()
            flagCollider.destroy()
            this.cleanup()

        }

        this.hero.on('died', () => { 
            this.failingSound.play()
            this.heroDieSound.play()
            removeCollidersOnce()
            this.hero.body.setCollideWorldBounds(false)
            this.cameras.main.stopFollow()

            this.gameOverImage = this.add.image(this.gameImagesX, this.gameImagesY, 'gameover')
                                .setScale(0.1).setScrollFactor(0, 0).setDepth(20)
            
            const tween = this.tweens.add({
                targets: this.gameOverImage,
                duration: 400,
                ease: 'Sine.easeIn',
                scale: 0.8
            })

            if (typeof window.updateScore === 'function') {
                window.updateScore(this.level, this.score, false, this.cat, this.enemy, this.ts)
            }
        })
        this.hero.on('destroy', () => {
            removeCollidersOnce()

            this.failingSound.destroy()
            this.heroDieSound.destroy()
            
            this.enemyWallCollider.destroy()
        })
        this.hero.setDepth(2)
    }

    addMap() {
        this.map = this.make.tilemap({ key: `level-${this.level}` })

        const groundTiles = this.map.addTilesetImage('ground', `world-${this.level}-sheet`)
        
        const environment_128_1_tiles = this.map.addTilesetImage('environment_128_1', 'environment-128-1-sheet')
        const environment_128_2_tiles = this.map.addTilesetImage('environment_128_2', 'environment-128-2-sheet')
        const environment_256_tiles = this.map.addTilesetImage('environment_256', 'environment-256-sheet')
        const environment_512_1_tiles = this.map.addTilesetImage('environment_512_1', 'environment-512-1-sheet')
        const environment_512_2_tiles = this.map.addTilesetImage('environment_512_2', 'environment-512-2-sheet')
        const environment_512_3_tiles = this.map.addTilesetImage('environment_512_3', 'environment-512-3-sheet')
        const environment_512_4_tiles = this.map.addTilesetImage('environment_512_4', 'environment-512-4-sheet')

        const environmentTilesArray = [
            groundTiles,
            environment_128_1_tiles, 
            environment_128_2_tiles, 
            environment_256_tiles,
            environment_512_1_tiles,
            environment_512_2_tiles,
            environment_512_3_tiles,
            environment_512_4_tiles
        ]

        
        // const trampolineTiles = this.map.addTilesetImage('trampoline', 'trampoline-sheet')
        const groundLayer = this.map.createStaticLayer('Ground', groundTiles)
        // groundLayer.addTiles(trampolineTiles)
        groundLayer.setCollision([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], true)

        const backgroundLayer = this.map.createStaticLayer('Background', environmentTilesArray)

        const foregroundLayer = this.map.createStaticLayer('Foreground', environmentTilesArray)
        foregroundLayer.setDepth(16)

        this.physics.world.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels)
        this.physics.world.setBoundsCollision(true, true, false, true)

        const enemyColliderLayer = this.map.createStaticLayer('ActorColliders', groundTiles)
        enemyColliderLayer.setCollision([10], true)
        enemyColliderLayer.setVisible(false)
        

        this.spikeGroup = this.physics.add.group({ immovable: true, allowGravity: false })
        this.ladderGroup = this.physics.add.group({ immovable: true, allowGravity: false })
        this.trampolineGroup = this.physics.add.group({ immovable: true, allowGravity: false })
        // this.enemyGroup = this.physics.add.group({ immovable: true, allowGravity: false })
        this.enemyGroup = new Phaser.GameObjects.Group()
        this.collectableGroup = this.physics.add.group({ immovable: true, allowGravity: false })

        this.map.getObjectLayer('Objects').objects.forEach(object => {
            if (object.name === 'Start') {
                this.spawnPos = {x: object.x, y: object.y}
            }
            if (object.gid === 15) {
                const spike = this.spikeGroup.create(object.x, object.y, `world-${this.level}-sheet`, object.gid - 1)
                spike.setOrigin(0, 1)
                spike.setSize(object.width - 30, object.height / 2 - 30)
                spike.setOffset(15, object.height/2 + 30)
            }
            if (object.gid === 12 || object.gid === 13 || object.gid === 14) {
                const ladder = this.ladderGroup.create(object.x, object.y, `world-${this.level}-sheet`, object.gid - 1)
                ladder.setOrigin(0, 1)
                ladder.setSize(object.width - 10, object.height / 2 + 10)
                // ladder.setOffset(5, object.height/2 + 10)
                ladder.body.checkCollision.up = true
                ladder.body.checkCollision.down = false
                ladder.body.checkCollision.left = false
                ladder.body.checkCollision.right = false
            }
            if (object.type === 'Trampoline') {
                const trampoline = this.trampolineGroup.create(object.x, object.y, 'trampoline-sheet', 0)
                trampoline.setOrigin(0, 1)
                trampoline.body.checkCollision.up = true
                trampoline.body.checkCollision.left = false
                trampoline.body.checkCollision.right = false
                trampoline.body.checkCollision.down = false
            }
            if (object.name === 'Actor') {
                // if (true || object.type === 'BasicRat') {
                    const enemy = new Enemy(this, object.x, object.y, object.type)
                    this.enemyGroup.add(enemy)
                // }
            }
            if (object.name === 'Collectable') {
                const collectable = this.collectableGroup.create(object.x, object.y, object.type)
                collectable.setOrigin(0, 1)
                // collectable.setScale(0.5)
                const tween = this.tweens.add({
                    targets: collectable,
                    y: collectable.y - 20,
                    duration: Phaser.Math.Between(500, 1500),
                    repeat: -1,
                    ease: 'Sine.easeInOut',
                    yoyo: true
                })
                collectable.on('destroy', () => {
                    tween && tween.stop && tween.stop()
                })
            }

            if (object.name === 'Flag') {
                this.flagSpawnPos = {x: object.x, y: object.y}
            }
            if (object.name === 'Cage') {
                this.cageSpawnPos = {x: object.x, y: object.y}
            }
        })
    }

    addFlagAndCage() {
        
        this.flag = this.physics.add.sprite(this.flagSpawnPos.x, this.flagSpawnPos.y + 5, 'flag', 0)
        
        this.capturedCat = this.add.sprite(this.cageSpawnPos.x, this.cageSpawnPos.y, `hero-${(this.level) % 10 + 1}-sheet`, 0)
                                .setOrigin(0.5, 1)
        this.cage = this.add.sprite(this.cageSpawnPos.x, this.cageSpawnPos.y + 40, 'cage', 0)

        this.flag.body.immovable = true
        this.flag.body.allowGravity = false

        this.flag.setOrigin(0, 1)
        this.cage.setOrigin(0.5, 1)

        this.flag.on('animationcomplete', this.onFlagOpen)
        this.capturedCat.anims.play(`hero-${(this.level) % 10 + 1}-idle`, true)

    }

    handleFlagOverlap = () => {
        if (this.hasOverlappedFlag) return;
        this.hasOverlappedFlag = true;
        this.flag.anims.play('flag-opening', true);
        // this.cage.anims.play('cage-opening', true);

        this.flagOverlapSound.play()

        let level = this.level;

        if (level + 1 > MAX_LEVELS) {
            // console.log('You won!')
            this.victoryImage = this.add.image(this.gameImagesX, this.gameImagesY, 'victory')
                                .setScale(0.1).setScrollFactor(0, 0).setDepth(20)
            const tween = this.tweens.add({
                targets: this.victoryImage,
                duration: 400,
                ease: 'Sine.easeIn',
                scale: 0.8
            })

            setTimeout(() => {
                try {
                    this.handleGoBack()

                } catch (e) {
                    console.warn(e)
                }
            }, 3000)
        } else {
            this.stageClearedImage = this.add.image(this.gameImagesX, this.gameImagesY, 'stagecleared')
                                .setScale(0.1).setScrollFactor(0, 0).setDepth(20)
            const tween = this.tweens.add({
                targets: this.stageClearedImage,
                duration: 400,
                ease: 'Sine.easeIn',
                scale: 0.8
            })
            setTimeout(() => {
                try {
                    if (this.scene.isActive('BlankScene')) {
                        // console.log('Cannot restart: Blank Scene already running')
                        return;
                    }
                    this.scene.restart({ level: ++this.level, score: 0 })
                } catch (e) {
                    console.warn(e)
                }
            }, 3000)
        }

        if (typeof window.updateScore === 'function') {
            window.updateScore(this.level, this.score, true, this.cat, this.enemy, this.ts)
        }
    }

    onFlagOpen = (animation) => {
        if (animation.key !== 'flag-opening') return;
        this.flag.anims.play('flag-flying', true)
        this.cage.anims.play('cage-opening', true)
    }

    cleanup = (died = true) => {
        // add any cleanup logic here
        // this.enemyWallCollider.destroy()
        // this.backgroundSound.stop()
            
        this.backgroundSound.destroy()
        this.jumpSound.destroy()
        this.collectSound.destroy()
        this.hitSound.destroy()
        this.flagOverlapSound.destroy()
        this.trampolineJumpSound.destroy()
        this.killEnemySound.destroy()
        
        // this.jumpSound.play()
    }

    update(time, delta) {
        const cameraBottom = this.cameras.main.getWorldPoint(0, this.cameras.main.height).y
        if (this.hero.isDead() && this.hero.getBounds().top > cameraBottom + 100 && !this.hasOverlappedFlag) {
            // died and out of bounds, restart level?
            this.scene.restart({ level: this.level })
        }
    }
}

export default Game